import { __decorate } from "tslib";
import { Component, Mixins } from "vue-property-decorator";
// SYSTEM1
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "../BaseMixer";
import { ServiceModel } from "@/store/models/service/AddService";
import { toaster } from "../../../utilities/toaster";
import ServiceModule from "@/store/modules/service.module";
let ServiceAdd = /** @class */ (() => {
    let ServiceAdd = class ServiceAdd extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            // DATA
            this.title = "Service";
            this.ctaButtons = [
                {
                    routeName: "Services",
                },
            ];
            this.items = [
                {
                    text: "Services",
                },
                {
                    text: "Add Service",
                    active: true,
                },
            ];
            this.pageIsLoading = true;
            this.service = new ServiceModel();
        }
        saveService() {
            this.validate("newUserObserver").then((response) => {
                if (response) {
                    ServiceModule.saveService(this.service).then((response) => {
                        toaster.ShowSuccess("Service was created successfully. ");
                        ServiceModule.GetServices().then((response) => { });
                        this.$router.push({ name: "Services" });
                    });
                }
            });
        }
        cancelService() {
            this.service = new ServiceModel();
            this.service = Object.assign({}, this.service);
            this.service = {
                id: this.service.id,
                name: this.service.name,
                latestVersion: this.service.latestVersion,
                description: this.service.description,
                price: this.service.price,
                url: this.service.url,
                userLimits: this.service.userLimits,
            };
            this.$router.push({ name: "Services" });
        }
        // LIFECYCLE
        created() {
            this.pageIsLoading = false;
        }
    };
    ServiceAdd = __decorate([
        Component({
            name: "ServiceAdd",
            components: {
                Layout,
                PageHeader,
            },
        })
    ], ServiceAdd);
    return ServiceAdd;
})();
export default ServiceAdd;
